export default __webpack_public_path__ + "static/media/pinetree.d841913d.png";